export default "__VITE_ASSET__30c08e23__"